import React from 'react';

import {StandardSemiBoldTypography} from 'patient-ping-remedy/packages/typography';
import {PingStatuses} from "@manual_encounters/constants/PingStatuses";
import PingStateText from "@manual_encounters/encounter_reconcile/pings/common/PingStateText";
import PingLocationText from "@manual_encounters/encounter_reconcile/pings/common/PingLocationText";
import PingDispositionText from "@manual_encounters/encounter_reconcile/pings/common/PingDispositionText";
import PingDateText from "@manual_encounters/encounter_reconcile/pings/common/PingDateText";
import PingVisitDurationText from "@manual_encounters/encounter_reconcile/pings/common/PingVisitDurationText";
import EncounterDiagnosis from "@manual_encounters/encounter_reconcile/pings/common/EncounterDiagnosis";
import {EncounterInfoFlexRow, StyledEncounterInfoAndPrograms, StyledEvent}
  from "@manual_encounters/encounter_reconcile/pings/patient/EncounterInfoAndPrograms.styles";

export default class EncounterInfoAndPrograms extends React.Component {

  render() {
    const { patient } = this.props;

    return (
      <EncounterInfoFlexRow>
        <StyledEncounterInfoAndPrograms className="patient-card-content">
          {!!patient.currentPing && !!patient.currentPingEncounter ? (
            <StyledEvent className="event-section" data-testid="event-section">
              {patient.currentPing.state === PingStatuses.CLOSED ? (
                <div>
                  ENCOUNTER CLOSED - update from{' '}
                  <span style={{ fontWeight: 'bolder' }}>
                    {patient.currentPingEncounter.admittingFacility
                      ? patient.currentPingEncounter.admittingFacility.name
                      : ' facility '}
                  </span>{' '}
                  never provided.
                </div>
              ) : (
                <div>
                  <StandardSemiBoldTypography>
                    <PingStateText ping={patient.currentPing} />{' '}
                  </StandardSemiBoldTypography>
                  <PingLocationText ping={patient.currentPing} />{' '}
                  <PingDispositionText ping={patient.currentPing} pingEncounter={patient.currentPingEncounter} />{' '}
                  <PingDateText
                    date={patient.currentPing.eventDate}
                    setting={patient.currentPing.setting}
                    facilityType={patient.currentPing.facility?.type}
                  />{' '}
                  <PingVisitDurationText
                    pingEncounter={patient.currentPingEncounter}
                    ping={patient.currentPing}
                    current={true}
                  />
                  {patient.currentPingEncounter?.diagnosis?.synonym && (
                    <span>
                      {' '}
                      for{' '}
                      <b>
                        <EncounterDiagnosis encounter={patient.currentPingEncounter} />
                      </b>
                    </span>
                  )}
                  .
                </div>
              )}
            </StyledEvent>
          ) : (
            <div className="event-section-empty-state">
              No client encounters yet.
            </div>
          )}
        </StyledEncounterInfoAndPrograms>
      </EncounterInfoFlexRow>
    );
  }
}
